<template>
  <el-card class="box-card">
    <div slot="header" class="header">用户生命周期监控</div>
    <el-row :gutter="20">
      <el-col :span="4">
        <span>渠道</span>

        <el-select
          v-model="lifeCycleChannelValue"
          placeholder="请选择"
          @change="lifeCycleChannelChange"
          multiple
          filterable
        >
          <el-option
            v-for="(item, index) in lifeCycleChannel"
            :key="index"
            :label="item.label"
            :value="item.value"
          ></el-option>
        </el-select>
      </el-col>
      <el-col :span="4">
        <span>国家</span>
        <el-select v-model="lifeCycleCountry" placeholder="请选择">
          <el-option
            v-for="(item, itemIndex) in countryList"
            v-bind:key="itemIndex + 99"
            :label="item.label"
            :value="item.value"
          ></el-option>
        </el-select>
      </el-col>

      <el-col :span="7">
        <span>日期</span>
        <DatePicker2 @datePickedChange="datePickedChange"></DatePicker2>
      </el-col>
      <el-col :span="4">
        <span>时间颗粒度</span>

        <el-select v-model="liftCycle" placeholder="请选择">
          <el-option label="日" value="day"></el-option>
          <el-option label="周" value="week"></el-option>
          <el-option label="月" value="month"></el-option>
        </el-select>
      </el-col>
      <el-col :span="2"
        ><el-button type="primary" @click="getList">查询</el-button></el-col
      >
    </el-row>
    <el-table :data="lifeCycleList" style="width: 100%">
      <el-table-column prop="date" label="日期" width="150"> </el-table-column>
      <el-table-column label="活跃用户数" width="150">
        <el-table-column prop="dau" label="Dau" width="150"> </el-table-column>
        <el-table-column
          prop="numberOfActiveUsers"
          label="有效活跃用户数"
          width="120"
        >
        </el-table-column>
        <el-table-column
          prop="numberOfRechargeActiveUsers"
          label="充值活跃用户数"
          width="150"
        >
        </el-table-column>
        <el-table-column
          prop="numberOfNonRechargeableActiveUsers"
          label="非充值活跃用户数"
          width="150"
        >
        </el-table-column>
      </el-table-column>

      <el-table-column label="新用户数" width="150">
        <el-table-column prop="totalNewUsers" label="总计" width="150">
        </el-table-column>
        <el-table-column
          prop="numberOfNewUsersRecharged"
          label="充值新用户数"
          width="150"
        >
        </el-table-column>
        <el-table-column
          prop="numberOfNewUsersNotRecharged"
          label="非充值新用户数"
          width="120"
        >
        </el-table-column>
      </el-table-column>

      <el-table-column label="留存用户数" width="150">
        <el-table-column
          prop="totalNumberOfRetainedUsers"
          label="总计"
          width="150"
        >
        </el-table-column>
        <el-table-column
          prop="numberOfUsersToRecharge"
          label="充值留存用户数"
          width="150"
        >
        </el-table-column>
        <el-table-column
          prop="numberOfNonRechargedRetainedUsers"
          label="非充值留存用户数"
          width="150"
        >
        </el-table-column>
      </el-table-column>

      <el-table-column label="回流用户数" width="150">
        <el-table-column
          prop="totalNumberOfReturnedUsers"
          label="总计"
          width="150"
        >
        </el-table-column>
        <el-table-column
          prop="numberOfRechargeReturnUsers"
          label="充值回流用户数"
          width="150"
        >
        </el-table-column>
        <el-table-column
          prop="numberOfNonRechargingBackflowUsers"
          label="非充值回流用户数"
          width="150"
        >
        </el-table-column>
      </el-table-column>

      <el-table-column label="沉默用户数" width="150">
        <el-table-column
          prop="totalNumberOfSilentUsers"
          label="总计"
          width="150"
        >
        </el-table-column>
        <el-table-column
          prop="numberOfRechargeSilentUsers"
          label="充值沉默用户数"
          width="150"
        >
        </el-table-column>
        <el-table-column
          prop="numberOfNonRechargedSilentUsers"
          label="非充值沉默用户数"
          width="150"
        >
        </el-table-column>
      </el-table-column>

      <el-table-column label="流失用户数" width="150">
        <el-table-column prop="totalNumberOfLostUsers" label="总计" width="150">
        </el-table-column>
        <el-table-column
          prop="numberOfUsersLostDuringRecharge"
          label="充值流失用户数"
          width="150"
        >
        </el-table-column>
        <el-table-column
          prop="numberOfNonRechargedLostUsers"
          label="非充值流失用户数"
          width="150"
        >
        </el-table-column>
      </el-table-column>
      <el-table-column
        prop="inflowOutflowRatio"
        label="流入流出/比"
        width="150"
      >
      </el-table-column>
    </el-table>
    <el-pagination
      background
      @current-change="handleCurrentChange"
      :current-page="currentPage"
      :page-size="14"
      layout="total, prev, pager, next, jumper"
      :total="lifeCycleList.length"
    ></el-pagination>
  </el-card>
</template>

<script>
import DatePicker2 from '../../components/DatePicker2'

export default {
  components: {
    DatePicker2
  },
  data() {
    return {
      lifeCycleList: [
        {
          date: '1',
          name: '1',
          province: '1',
          city: '1',
          address: '1',
          zip: 1
        }
      ],
      lifeCycleCountry: 'total',
      currentPage: 1,
      loading: true,
      datePicked: [
        this.$store.getters.dateTwoDayBefore,
        this.$store.getters.dateOneDayBefore
      ],
      lifeCycleChannel: this.$store.state.channels,
      lifeCycleChannelValue: ['total'],
      liftCycle: 'day',
      countryList: [
        { value: 'all' },
        { value: 'total' },
        { value: 'India' },
        { value: 'Malaysia' },
        { value: 'Indonesia' },
        { value: 'Pakistan' },
        { value: 'United States' },
        { value: 'Turkey' },
        { value: 'Philippines' },
        { value: 'Egypt' },
        { value: 'Vietnam' },
        { value: 'Saudi Arabia' },
        { value: 'Iraq' },
        { value: 'Brazil' },
        { value: 'Thailand' },
        { value: 'Mexico' },
        { value: 'Germany' },
        { value: 'United Arab Emirates' },
        { value: 'United Kingdom' },
        { value: 'Russia' },
        { value: 'Bangladesh' },
        { value: 'Hashemite Kingdom of Jordan' },
        { value: 'Sri Lanka' },
        { value: 'Italy' },
        { value: 'France' },
        { value: 'Israel' },
        { value: 'Algeria' },
        { value: 'Singapore' },
        { value: 'Morocco' },
        { value: 'Kuwait' },
        { value: 'Qatar' },
        { value: 'Chile' },
        { value: 'Colombia' },
        { value: 'South Korea' },
        { value: 'Lebanon' },
        { value: 'Canada' },
        { value: 'Nepal' },
        { value: 'Tunisia' },
        { value: 'Ukraine' },
        { value: 'Myanmar' },
        { value: 'Romania' },
        { value: 'Cambodia' },
        { value: 'Japan' },
        { value: 'Oman' },
        { value: 'Netherlands' },
        { value: 'Australia' },
        { value: 'Libya' },
        { value: 'Palestine' },
        { value: 'Spain' },
        { value: 'South Africa' },
        { value: 'Albania' },
        { value: 'Greece' }
      ]
    }
  },
  computed: {
    username() {
      return this.$store.getters.username
    },
    userLevel() {
      return this.$store.getters.userLevel
    },
    token() {
      return this.$store.getters.token
    }
  },
  mounted() {
    this.getList()
  },
  methods: {
    lifeCycleChannelChange(currentVal) {
      const currentValLen = currentVal.length
      if (currentValLen !== 1) {
        if (
          currentVal[currentValLen - 1] === 'total' ||
          currentVal[currentValLen - 1] === 'all'
        ) {
          this.lifeCycleChannelValue = [currentVal[currentValLen - 1]]
        }
      }

      if (currentValLen === 2) {
        if (currentVal[0] === 'total' || currentVal[0] === 'all') {
          this.lifeCycleChannelValue = [currentVal[currentValLen - 1]]
        }
      }
    },
    datePickedChange(date) {
      this.datePicked = date
    },
    handleCurrentChange(val) {
      this.currentPage = val
    },
    //用户生命周期数据
    getList() {
      this.loading = true
      this.$axios({
        type: 'GET',
        url: this.$store.getters.path.life_cycle,
        withCredentials: true,
        params: {
          username: this.username,
          token: this.token,
          start: this.datePicked[0],
          end: this.datePicked[1],
          channel: this.lifeCycleChannelValue.join(','),
          cycle: this.liftCycle,
          country: this.lifeCycleCountry
        }
      })
        .then(
          res => {
            if (res.data.code === 0) {
              this.lifeCycleList = res.data.data
            } else if (res.data.code === 1001) {
              this.$message({
                showClose: true,
                message: res.data.msg,
                type: 'error'
              })
              this.$router.push(this.$route.query.redirect || '/login')
            } else {
              this.$message({
                showClose: true,
                message: res.data.msg,
                type: 'error'
              })
            }
          },
          err => {
            this.$message({
              showClose: true,
              message: '请求错误:' + err,
              type: 'error'
            })
          }
        )
        .then(() => {
          this.loading = false
        })
    }
  }
}
</script>

<style  lang='stylus'>
.box-card {
  margin: 20px;
  min-width: 1200px;

  .header {
    font-size: 28px;
    font-weight: bold;
  }

  .cell {
    text-align: center;
  }

  .el-row {
    margin-bottom: 20px;
  }

  .el-pagination {
    margin-top: 20px;
  }

  .el-col {
    display: flex;
    align-items: center;

    >span {
      display: inline-block;
      margin: 0 10px;
      white-space: nowrap;
      font-size: 13px;
    }
  }
}
</style>
